import React, { useState, useContext } from 'react';
import { FaUpload } from 'react-icons/fa';
import ProgressBar from './ProgressBar';
import { IconContext } from "react-icons";
import {useDropzone} from 'react-dropzone';
import { upload } from '../../scripts/dataTable';
import { paths } from '../../config/app-config';
import { importExportContext } from '../../context/importExportContext';

const UploadCard = (props) => {

  const [ uploadPercentage, setUploadPercentage ] = useState(0);
  const { setUploadStatus, setUploadSummary } = useContext(importExportContext);

  const onDrop = async files => {
    // Send the accepted files via /upload backend link
    const {status, summary} = await upload({
      files,
      uploadUrl: props.fullUrl || paths.uploadPath(props.from),
      data: props.data,
      setContext: setUploadPercentage
    });

    setUploadStatus(status);
    setUploadSummary(summary);
    // Reset Percent Complete once summary is shown to remove progress bar
    setUploadPercentage(0);
  }

  const {getRootProps,getInputProps} = useDropzone({
    onDrop,
    accept: '.csv'
  });

  return (
    <div className="pda-drag-drop-card">
      <div {...getRootProps({className: 'pda-drag-drop-card-body'})}>
        <input {...getInputProps()} data-testid="upload-input" />
        <h5>Drag and Drop a .CSV file here to upload</h5>
        <h6>or click to locate the file on your computer</h6>
          <div className="pda-upload-icon">
            <IconContext.Provider value={{ color: "#312f2f", size:"1.5em" }}>
              <div>
                <FaUpload/>
              </div>
            </IconContext.Provider>
          </div>
          <ProgressBar percentComplete={uploadPercentage} />
      </div>
    </div>
  )
}

export default UploadCard;
